'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _plugin = require('@swup/plugin');

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GaPlugin = function (_Plugin) {
	_inherits(GaPlugin, _Plugin);

	function GaPlugin(options) {
		_classCallCheck(this, GaPlugin);

		var _this = _possibleConstructorReturn(this, (GaPlugin.__proto__ || Object.getPrototypeOf(GaPlugin)).call(this));

		_this.name = 'GaPlugin';

		var defaultOptions = {
			gaMeasurementId: null
		};

		_this.options = _extends({}, defaultOptions, options);
		return _this;
	}

	_createClass(GaPlugin, [{
		key: 'mount',
		value: function mount() {
			var _this2 = this;

			this.swup.on('contentReplaced', function (event) {
				if (typeof gtag === 'function') {
					var title = document.title;
					var url = window.location.pathname + window.location.search;
					var gaId = _this2.options.gaMeasurementId;

					if (!gaId) {
						throw new Error('gaMeasurementId option is required for gtag.');
					}

					window.gtag('config', gaId, {
						page_title: title,
						page_path: url
					});
					_this2.swup.log('GTAG pageview (url \'' + url + '\').');
				} else if (typeof window.ga === 'function') {
					var _title = document.title;
					var _url = window.location.pathname + window.location.search;

					window.ga('set', 'title', _title);
					window.ga('set', 'page', _url);
					window.ga('send', 'pageview');

					_this2.swup.log('GA pageview (url \'' + _url + '\').');
				} else {
					console.warn("window.gtag and window.ga don't exists.");
				}
			});
		}
	}]);

	return GaPlugin;
}(_plugin2.default);

exports.default = GaPlugin;